// Auto-rotating testimonial carousel with dot navigation
document.addEventListener('DOMContentLoaded', function () {
  var slider = document.querySelector('.multicolumn-list.slider');
  if (!slider) return;

  var slides = slider.querySelectorAll('.slider__slide');
  if (slides.length <= 3) return;

  // Calculate number of pages (groups of 3)
  var perPage = 3;
  var totalPages = Math.ceil(slides.length / perPage);
  var currentPage = 0;

  // Replace dots to match page count
  var dotsContainer = document.querySelector('.nhs-slider-dots');
  if (!dotsContainer) return;

  dotsContainer.innerHTML = '';
  for (var i = 0; i < totalPages; i++) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'nhs-dot' + (i === 0 ? ' nhs-dot--active' : '');
    dot.setAttribute('data-page-index', i);
    dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
    dotsContainer.appendChild(dot);
  }

  var dots = dotsContainer.querySelectorAll('.nhs-dot');

  function updateDots(page) {
    dots.forEach(function (dot, i) {
      dot.classList.toggle('nhs-dot--active', i === page);
    });
  }

  function scrollToPage(page) {
    var slideIndex = page * perPage;
    if (slideIndex >= slides.length) slideIndex = 0;
    var slide = slides[slideIndex];
    if (!slide) return;
    slider.scrollTo({
      left: slide.offsetLeft - slider.offsetLeft,
      behavior: 'smooth'
    });
    currentPage = page;
    updateDots(page);
  }

  function nextPage() {
    currentPage = (currentPage + 1) % totalPages;
    scrollToPage(currentPage);
  }

  // Dot click navigation
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var page = parseInt(this.getAttribute('data-page-index'), 10);
      clearInterval(autoPlay);
      scrollToPage(page);
      autoPlay = setInterval(nextPage, 4000);
    });
  });

  // Auto-play
  var autoPlay = setInterval(nextPage, 4000);

  // Pause on hover
  slider.addEventListener('mouseenter', function () {
    clearInterval(autoPlay);
  });

  slider.addEventListener('mouseleave', function () {
    autoPlay = setInterval(nextPage, 4000);
  });

  // Pause on touch
  slider.addEventListener('touchstart', function () {
    clearInterval(autoPlay);
  });

  slider.addEventListener('touchend', function () {
    autoPlay = setInterval(nextPage, 4000);
  });
});
